import React from 'react';
import PropTypes from 'prop-types';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';

import SlackLinked from './SlackLinked';
import SlackNotLinked from './SlackNotLinked';

export default function Slack({ channels, isLoaded }) {
  if (!isLoaded) {
    return (
      <div className="content pt-5 pb-5">
        <LoadingPlaceholder text="Loading..." />
      </div>
    );
  }

  return channels === null ? <SlackNotLinked /> : <SlackLinked channels={channels} />;
}

Slack.propTypes = {
  channels: PropTypes.object,
  isLoaded: PropTypes.bool.isRequired,
};

Slack.defaultProps = {
  channels: null,
};
